import { LOGIN, SET_USER, CODE_BLUE, INVENTORY_ALERT, LOGOUT, SET_PARAMS, SET_SHIFT } from "../actionTypes"

const initial = { 
    user: null,
    shift: null,
    params: {},
    codeBlue: undefined,
    lastInventoryAlert: null,
    loggedIn: sessionStorage.getItem('token') ? true : false,
    token: sessionStorage.getItem('token')
}

const application = (state = initial, action) => {
    switch (action.type) {
        // Auth
        case LOGIN:
            sessionStorage.setItem('token', action.token)

            return {
                ...state,
                loggedIn: true,
                token: action.token
            }

        case SET_USER:
            return {
                ...state,
                user: action.user
            }

        case CODE_BLUE:
            let cb
            if (action.data)
                cb = action.data

            return {
                ...state,
                codeBlue: cb
            }

        case INVENTORY_ALERT:
            return {
                ...state,
                lastInventoryAlert: action.data ? {
                    ...action.data,
                    at: Date.now()
                } : null
            }

        case SET_SHIFT:
            return {
                ...state,
                shift: action.shift
            }

        case LOGOUT:
            sessionStorage.removeItem('token')

            return {
                ...state,
                loggedIn: false,
                token: null,
                user: null
            }

        case SET_PARAMS:
            return {
                ...state,
                params: action.params
            }

        default:
            return state
    }
}

export default application
